import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { ACTIVE_MODULE } from "app/_constants/constant";

import { useForm } from "app/_helpers/hooks";
import { Col, Row, Button } from "react-bootstrap";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import MultiSelectWithCheckbox from "app/Components/SearchableSelect/MultiSelectCkeckOption";
import { downloadVflExcelReports } from "app/_services/ehs/ehsReportServices";
import DateRangePickerCustom from "app/Components/DateTimeCustom/DateRangePickerCustom";
import moment from "moment";
import toastr from "toastr";

function VFLExcel() {
  const [sites, setSites] = useState([]);
  const [form, setForm] = useState({});
  const mines = useMemo(() => sites.filter((site) => +site.siteType === 3), [sites]);
  const onReset = async () => {
    console.log("cliked");
  };
  const onSubmit = async () => {
    if (!form?.sites || !form?.dates?.startDate || !form?.dates?.endDate) {
      toastr.warning("All fields are required");
      return;
    }
    const response = await downloadVflExcelReports(form);

    console.log("cliked");
  };
  useEffect(() => {
    getAllSites("filter[status]=1&filter[activeStatus]=active").then((response) => {
      if (!response?.data) return;

      setSites(response.data);
    });
  }, []);
  const onChange = ({ target: { name, type, value, checked } }) => {
    setForm((prevForm) => {
      const newForm = {
        ...prevForm,
        [name]: type === "checkbox" ? checked : value,
      };
      return newForm;
    });
  };

  console.log("form", form);
  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "VFLs", path: "#" },
          {
            name: "VFL Excels",
            path: "#",
          },
        ]}
        module={ACTIVE_MODULE.vfl}
        breadCrumbsText="User_Management_User_Registration"
      />

      <Row>
        <Col md="4">
          <div className="form-group">
            <label>Location</label>
            <MultiSelectWithCheckbox
              options={sites?.map((d) => {
                return {
                  label: d.name,
                  id: d.id,
                  value: d.id,
                  siteType: d?.siteType,
                };
              })}
              value={form?.sites?.split(",")?.map((id) => {
                const found = sites.find((site) => site.id === +id);
                return {
                  label: found?.name,
                  id: found?.id,
                  value: found?.id,
                  siteType: found?.siteType,
                };
              })}
              onChange={(selectedSites) => {
                onChange({
                  target: {
                    name: "sites",
                    value: selectedSites?.map((site) => site.id).join(","),
                  },
                });
              }}
              hasSelectAll={false}
              disableSearch={false}
            />
            {/* <span className="text-danger small">{errorForm.siteIds}</span> */}
          </div>
        </Col>
        <Col md="4">
          <div className="form-group">
            <label>Date Range</label>
            <DateRangePickerCustom
              startDate={""}
              endDate={""}
              handleSelect={(dates) => {
                if (!dates?.startDate || !dates?.endDate) return;

                console.log(dates);

                onChange({
                  target: {
                    name: "dates",
                    value: {
                      startDate: moment(dates.startDate).format("YYYY-MM-DD"),
                      endDate: moment(dates.endDate).format("YYYY-MM-DD"),
                    },
                  },
                });
              }}
            />
          </div>
        </Col>
      </Row>

      <div className="mb-2 text-center">
        <Button
          onClick={onSubmit}
          type="submit"
          variant="primary"
          className="m-1 text-capitalize"
        >
          Submit
        </Button>
      </div>
    </div>
  );
}

export default VFLExcel;
